import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SelectV2Component } from '@app/formly/types/v2/select-v2/select-v2.component';

@Component({
  selector: 'credit-card-v2',
  templateUrl: './credit-card-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditCardV2Component extends SelectV2Component {}
